import PropTypes from "prop-types";
import React, { useState } from "react";
import TemporaryAssignmentDetailDialog from "./TemporaryAssignmentDetailDialog.jsx";

const TemporaryAssignmentEmployee = (props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClickDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleClickDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    setIsDialogOpen(false);
  };

  return (
    <div data-testid="temporary-assignment-employee-component">
      <span data-testid="temporary-assignment-employee-link" className="text-link" onClick={handleClickDialogOpen}>
        {props.tempAssignment.searchFormat.employee}
      </span>
      {isDialogOpen && (
        <TemporaryAssignmentDetailDialog
          tempAssignmentReferenceNumber={props.tempAssignment.referenceNumber}
          isDialogOpen={isDialogOpen}
          handleClickDialogClose={handleClickDialogClose}
          handleEditClick={props.handleEditClick}
        />
      )}
    </div>
  );
};

TemporaryAssignmentEmployee.propTypes = {
  tempAssignment: PropTypes.object.isRequired,
  handleEditClick: PropTypes.func.isRequired,
};

export default TemporaryAssignmentEmployee;
